module.exports = __webpack_public_path__ + "static/img/042_4.eab7e1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_4.jpg
// module id = 3ruQ
// module chunks = 1